<template>
  <a-dialog
    ref="dialog"
    size="large"
    :persistent="false"
    dense="mobile"
    :toolbar="true"
    :actions="false"
    name="check_serp"
    :progress="progress"
    @open="opened"
    @close="$reset">
    <span slot="title" v-if="checkPicker.currentCheck">
      {{ checkPicker.currentCheck.keyword.term }}
      (<geo-lang-name
      size="sm"
      :country="checkPicker.currentCheck.keyword.country"
      :language="checkPicker.currentCheck.keyword.language">
      </geo-lang-name>)
      - {{ checkPicker.currentCheck.domain }}
    </span>
    <div slot="content">
      <div class="mt-4">
        <v-row>
          <v-col cols="12" md="4" :order="this.$vuetify.breakpoint.smAndDown ? 'last' : 'first'">
            <v-btn :href="currentSerp ? getSerpUrl() : ''" :disabled="!currentSerp" target="_blank" depressed
                   small>
              <v-icon small left>mdi-open-in-new</v-icon>
              {{ $t('actions.view') }}
            </v-btn>
          </v-col>
          <v-col cols="12" md="8" :order="this.$vuetify.breakpoint.smAndDown ? 'first' : 'last'">
            <check-picker
              :class="this.$vuetify.breakpoint.smAndDown ? '' : 'float-right'"
              :current-check="checkPicker.currentCheck"
              :current-check-datacenter="checkPicker.currentDatacenter"
              :similar-checks="similarChecks"
              @changed="handleCheckPickerChanged"
            ></check-picker>
          </v-col>
        </v-row>
      </div>

      <div class="mt-4">
        <serp-dialog-detail-table
          :serp="currentSerp"
          :comparison="comparisonSerp"
          :skeleton-no-comparison="checkPicker.comparisonDatacenter === null"
        >
        </serp-dialog-detail-table>
      </div>
    </div>
  </a-dialog>
</template>

<script>
import SerpDialogDetailTable from '@/views/Common/Components/SerpDetail/SerpDialogDetailTable'
import CheckPicker from '@/views/Pages/DatacenterCheck/Components/Common/CheckPicker'
import GeoLangName from '@/views/Common/Components/GeoLang/GeoLangName'
import { debounce } from 'lodash'

export default {
  name: 'CheckSerpDialog',
  components: { GeoLangName, CheckPicker, SerpDialogDetailTable },
  data () {
    return {
      progress: false,
      currentSerp: null,
      comparisonSerp: null,
      similarChecks: [],
      checkPicker: {
        currentCheck: null,
        currentDatacenter: null,
        comparisonCheck: null,
        comparisonDatacenter: null
      },
    }
  },
  methods: {
    handleCheckPickerChanged ({ current, comparison }) {
      this.checkPicker.currentCheck = current.check
      this.checkPicker.currentDatacenter = current.datacenter
      this.checkPicker.comparisonCheck = comparison.check
      this.checkPicker.comparisonDatacenter = comparison.datacenter
      this.fetch()
    },
    getSerpUrl () {
      const url = this.currentSerp.page().url
      if(!url) return ''

      const parsed = new URL(this.currentSerp.page().url);
      parsed.hostname = this.currentSerp.request().google_domain
      return parsed.href
    },
    fetch: debounce(async function () {
      this.progress = true

      try {
        const url = this.$models.CarrierObjects.checkSerp(this.checkPicker.currentCheck, this.checkPicker.currentDatacenter.replace(/\./g, ''))
        const result = await this.$carrier.get(url)
        this.currentSerp = this.$models.serp.get(result.data)
      } catch (e) {
        console.error(e)
        this.currentSerp = false
      }

      if (this.checkPicker.comparisonDatacenter) {
        try {
          const compUrl = this.$models.CarrierObjects.checkSerp(this.checkPicker.comparisonCheck, this.checkPicker.comparisonDatacenter.replace(/\./g, ''))
          const result = await this.$carrier.get(compUrl)
          this.comparisonSerp = this.$models.serp.get(result.data)
        } catch (e) {
          console.error(e)
          this.comparisonSerp = null
        }
      }

      this.similarChecks = (await this.$api.get('checks', {
        where: {
          keyword_id: this.checkPicker.currentCheck.keyword.id,
          domain: this.checkPicker.currentCheck.domain
        },
        order_by: {
          id: 'desc'
        },
        limit: 20
      }, {
        showLoading: false
      })).data

      this.progress = false
    }, 200),
    async opened ({ check, datacenter }) {
      this.checkPicker.currentCheck = check
      this.checkPicker.currentDatacenter = datacenter

      await this.fetch()
    }
  }
}
</script>